import { BINOptionsCore } from "typings/IComponentsLib";

async function openBookItNow(popupParams: LSHelper.Calendar.EditReservationParams, onSuccessCallback?: (reservationId?: Guid, occurrenceDate?: string) => void, onCloseCallback?: (isSuccess: boolean) => void) {
   const { default: LiquidSpaceEmbedded } = await import("LiquidSpaceEmbedded");
   LiquidSpaceEmbedded.actions["ls-editReservation"]({
      onSuccessCallback,
      onCloseCallback,
      popupParams
   });
}

//Test approach to use NEW BIN directly
//See \Components\VenueCalendarModal\ReservationCalendar\index.tsx
async function openNewBin(options: BINOptionsCore) {
   const modals = await import("features/ComponentsLib/BookModal");
   modals.default(options);
}

export function useBookItNow() {
   return {
      openBookItNow,
      openNewBin
   };
}
